import {Button} from "@varymadellc/my-weed-club-component-library";
import {useAuth} from "@/providers/AuthProvider";
import {socket} from "@/services/socketService";
import Page from "@/layout/Page";

export default function Index() {
    const {signOut} = useAuth();

    return (
        <Page title="Index">
            <div className="w-10/12 lg:w-6/12 mx-auto text-center">
                <div className="text-start justify">
                    <p className="text-lg">Checking out huh? Well we hope to see you come back soon.</p>
                    <p>We add new features all the time! If you ever wonder when something is new, just checkout the
                        version number below. When it changes, then something is new or fixed!</p>
                    <br/>
                    <p className="text-sm">Your login automatically expires after 24 hours.</p>
                </div>
                <div className="text-center">
                    <Button onClick={() => {
                        socket.disconnect();
                        signOut()
                    }}>Sign out now.</Button>
                </div>
            </div>
        </Page>
    )
}